import React from 'react'
import { ChatbotStepActionData, CustomAPICallActionData } from '../../../../models/flowBuilderTypes';
import { Grid, Typography } from '@mui/material';
import styles from "../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss";
import { useWebhookStore } from '../../../../store/webhookStore';
import { getConfiguredWebhook } from '../flowBuilderConstants';

interface WebhookNodeProps {
    id: string, 
    data: ChatbotStepActionData<any>,
} 

const WebhookNode: React.FC<WebhookNodeProps> = (props) => { 

    const {id, data} = props;

    const configuredWebhookData = useWebhookStore((state) => state.configuredWebhookData)

    return (
        <>
            {data.action_data?.action_await_webhook_id ? 
                <Grid container direction={"column"} gap={"4px"}>
                    <Typography className={styles.dataSavedTextStyle}>{`Await Webhook `}</Typography>
                    <Grid container direction={"column"} gap={"4px"}>
                        <Grid item className={styles.dataSavedValueStyle}>
                            {getConfiguredWebhook(configuredWebhookData, data?.action_data?.webhook_organization_id) ? getConfiguredWebhook(configuredWebhookData, data?.action_data?.webhook_organization_id)?.webhook_external?.webhook_external_company_name : ""}
                        </Grid> 
                        <Grid item className={styles.dataSavedValueStyle}>
                            {getConfiguredWebhook(configuredWebhookData, data?.action_data?.webhook_organization_id) ? getConfiguredWebhook(configuredWebhookData, data?.action_data?.webhook_organization_id)?.webhook_organization_full_path : ""}
                        </Grid>
                    </Grid>
                </Grid>
                :
                <>
                    <div>
                        <span className={styles.dataSavedTextStyle}>{`Await Webhook `}</span>
                        <span className={styles.dataSavedValueStyle}>
                            Please Configure Await Webhook*
                        </span>
                    </div>
                </>
            }
        </>
    )
}

export default WebhookNode
